import { useState } from "react";
import { Button, Form, FormGroup, Input, InputGroup, InputGroupText, Label } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { CreateAccount, EmailAddress, ForgotPassword, Login, Password, RememberPassword, SignIn } from "../Constant";
import { toast } from "react-toastify";
import { Mail, Lock } from "react-feather";
import MediaIcons from "../CommonElements/MediaIcons";

export default function SignInForm() {
  const history = useNavigate();
  const [email, setEmail] = useState("test123@gmail.com");
  const [password, setPassword] = useState("Test@123");
  const [isPasswordVisible,setisPasswordVisible] = useState(false);

  const toggle = () =>{ setisPasswordVisible(!isPasswordVisible)};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email === "test123@gmail.com" && password === "Test@123") {
      toast.success("Login Success...!");
      history(`${process.env.PUBLIC_URL}/dashboard/default`);
      localStorage.setItem("login", JSON.stringify(true));
    } else {
      toast.error("Please Enter valid email or password...!");
    }
  };

  return (
    <div className='login-card1'>
      <Form className='theme-form login-form'>
        <div className='login-header text-center'>
          <h4>{Login}</h4>
          <h6>Welcome back! Log in to your account.</h6>
        </div>

        <FormGroup>
          <Label>{EmailAddress}</Label>
          <InputGroup>
            <InputGroupText>
              <Mail />
            </InputGroupText>
            <Input type='email' required placeholder='Test@gmail.com' defaultValue={email} onChange={(event) => setEmail(event.target.value)} />
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label>{Password}</Label>
          <InputGroup>
            <InputGroupText>
              <Lock />
            </InputGroupText>
            <Input type={isPasswordVisible ? "text" : "password"} name='login[password]' required defaultValue={password} onChange={(event) => setPassword(event.target.value)} />
            
          
            <div className='show-hide' onClick={toggle}>
              <span className={!isPasswordVisible ? "show" : ""}></span>
            </div>
          </InputGroup>
        </FormGroup>

        <FormGroup className='login-btn'>
          <div className='checkbox'>
            <Input id='checkbox1' type='checkbox' />
            <Label className='text-muted' for='checkbox1'>
              {RememberPassword}
            </Label>
          </div>
          <Link href='/pages/authentication/forgetpwd' className='link'>
            {ForgotPassword}?
          </Link>
        </FormGroup>
        <FormGroup>
          <Button className='btn-block' color='primary' type='submit' onClick={handleSubmit}>
            {SignIn}
          </Button>
        </FormGroup>
        <div className='login-social-title'>
          <h5>Sign in with Email</h5>
        </div>
        <FormGroup>
          <MediaIcons />
        </FormGroup>
        <p>
          Don't have account?
          <Link href='/pages/authentication/create-pwd' className='ms-2'>
            {CreateAccount}
          </Link>
        </p>
      </Form>
    </div>
  );
}
